import React, { useEffect, useState } from "react";
import ClientLogo from "../AccountDetails/ClientLogo";

export default function AddLogo({
  project_id,
  setContinueWithoutLogo,
  clientId,
}) {
  const [showLoad, setShowLoad] = useState(false);
  const [exLogo1, setExLogo1] = useState(null);
  useEffect(() => {
    if (exLogo1) {
      setContinueWithoutLogo(true);
    }
  }, [exLogo1]);

  return (
    <>
      <div className="add-logo-popup-wrapper">
        <div className="tab-pane fade show add-logo-div">
          <div>
            <span
              style={{ margin: "10px", padding: "3px", textAlign: "center" }}
            >
              <h3>
                We didn't find a Logo for this Client. Do you wish to add one?
              </h3>
            </span>
            <center>
              <button
                type="button"
                className="btn base-btn prjdetails-editCancel m-3"
                onClick={() => {
                  setShowLoad(true);
                }}
              >
                Add a logo
              </button>
              <button
                type="button"
                className="btn base-btn prjdetails-editCancel m-3"
                onClick={() => setContinueWithoutLogo(true)}
              >
                Continue without logo
              </button>
            </center>
            {showLoad ? (
              <center className="container" style={{ position: "relative" }}>
                <ClientLogo
                  client_id={clientId}
                  exLogo1={exLogo1}
                  setExLogo1={setExLogo1}
                  showLoad={showLoad}
                  setShowLoad={setShowLoad}
                />
              </center>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
